/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Base from 'shared/client/behavior/base';


export default class extends Base
{
  canNavigate ()
  {
    return false;
  }


  canSelect ()
  {
    return true;
  }


  isPaneCollapsed ()
  {
    return true;
  }


  getSelectShape (source, galaxy)
  {
    const unit = source.getZone().getUnit();

    return galaxy.getConstants().getUnit(unit.getType()).getTargetShape();
  }


};
